import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';
import Immutable from 'seamless-immutable';

@seamlessImmutable
class TermsStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.on('bootstrap', seamlessBootstrap.bind(this, null));
    this.state = Immutable({
      policyList: [],
      vbuckscardterms: null,
    });
  }
}

export default alt.createStore(TermsStore, 'TermsStore');
